"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var element_1 = require("../../../element");
var section_1 = require("../section");
var base_1 = require("./base");
var colorScale = {
    gneg: "#fff",
    gpos25: "#aaa",
    gpos50: "#777",
    gpos75: "#333",
    gpos100: "#000",
    acen: "#a00",
    gvar: "#000",
};
var CytoBand = /** @class */ (function (_super) {
    __extends(CytoBand, _super);
    function CytoBand() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.thickness = 25;
        return _this;
    }
    CytoBand.prototype.init = function () {
        var _this = this;
        _super.prototype.init.call(this);
        this.elements.pop();
        this._sections = this.appendGroupT(SectionCytoBand).options({
            _fromAng: function (d) { return _this.circos.startAngleForChr(d._key); },
            _toAng: function (d) { return _this.circos.endAngleForChr(d._key); },
            _padAng: function (d) { return _this.circos.padAngleForChr(d._key); },
            _innerR: function (d) { return _this.getInnerR(d._key); },
            _outerR: function (d) { return _this.getOuterR(d._key); },
        });
        this._sections.cytobandLayer = this;
    };
    return CytoBand;
}(base_1.Layer));
exports.CytoBand = CytoBand;
var SectionCytoBand = /** @class */ (function (_super) {
    __extends(SectionCytoBand, _super);
    function SectionCytoBand() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.background = "rgba(255,255,255,.6)";
        return _this;
    }
    SectionCytoBand.prototype.init = function () {
        var _this = this;
        _super.prototype.init.call(this);
        this.appendGroupT(element_1.Arc).options({
            _data: function (d, i, g) {
                var start = _this.getOption("_fromAng", d, i, g);
                var end = _this.getOption("_toAng", d, i, g);
                var pad = _this.getOption("_padAng", d, i, g);
                var data = d.data || { bands: [] };
                var bands = data.bands;
                var min = d3.min(bands, function (x) { return x.start; });
                var max = d3.max(bands, function (x) { return x.end; });
                var scale = d3.scaleLinear().range([start + pad, end - pad]).domain([min, max]);
                return bands.map(function (b) { return (__assign(__assign({}, b), { start: scale(b.start), end: scale(b.end), color: b.stain, innerR: _this.cytobandLayer.getInnerR(d._key) + 1, outerR: _this.cytobandLayer.getOuterR(d._key) - 1 })); });
            },
            _startAngle: function (d) { return d.start; },
            _endAngle: function (d) { return d.end; },
            _padAngle: 0,
            _innerR: function (d) { return d.innerR; },
            _outerR: function (d) { return d.outerR; },
            _tooltip: function (d) { return "" + d.name; },
            fill: function (d) { return colorScale[d.color]; },
        });
    };
    return SectionCytoBand;
}(section_1.Section));
exports.SectionCytoBand = SectionCytoBand;
//# sourceMappingURL=cytoband.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/circos/layers/cytoband.js
// module id = 1180
// module chunks = 0 1